import { ActionType } from '../schema/telemetry/ActionType';
import { TodoActionTelemetryData } from '../schema/telemetry/TodoActionTelemetryData';
import { getMailAriaTenantTokens } from 'owa-analytics';
import { DatapointConfig } from 'owa-analytics-actions';
import { TodoActionCustomData } from '../schema/telemetry/TodoActionCustomData';

const todoOptions = {
    isCore: true,
    tenantTokens: getMailAriaTenantTokens(),
};

export function createDatapointConfig(
    actionType: ActionType,
    telemetryData: TodoActionTelemetryData
): DatapointConfig {
    const { viewType, actionSource, scenarioSessionId } = telemetryData;
    const customData: TodoActionCustomData = {
        actionType_1: actionType,
        actionSource_2: actionSource,
        viewType_3: viewType,
        scenarioSessionId: scenarioSessionId ? scenarioSessionId : '',
    };
    return {
        name: 'TodoAction',
        options: todoOptions,
        customData: customData,
    };
}
